import { DatCache } from 'api/datCache';
import { GenericAPICall } from 'api/genericAPICall';
import { LogStream } from 'generics/common';
import { SettingsInjections } from 'generics/settingsInjections';

LogStream.enable( "APICALLDEBUG" );

////////////////////////////////////////////
// class StatAPICall
class StatAPICall  extends GenericAPICall {
  getInterfaceUrl()  {
    return SettingsInjections.getUsedCircuit().userstat_server;
  }
};

export function GetGlobalStat( appid ) {
  let callStat = new StatAPICall("cln_get_global_stats");

  callStat.append("appid", appid);

  return callStat.POST().then( (resp) =>  {
    LogStream( "APICALLDEBUG" ).info(`GetGlobalStat - got response:`, resp);

    return resp;
  });
}

////////////////////////////////////////////
class StatCache extends DatCache  {
  constructor()  {
    super({name:"globalstathash", timeoutMin: 30});
  }

  fetch( key, [  appid  ] )  {
    return GetGlobalStat( appid );
  }
}

export const StatCacheResolver = new StatCache();